import type { UserJobListPublic, UserJobPublic } from '@/manage/types/user'
import { jobProfileStorage } from '@/utils/storage/jobProfiles'

type DraftableJob = Pick<UserJobListPublic, 'open_at'> | Pick<UserJobPublic, 'open_at'> | null | undefined
type JobDisplayNameSource =
  | Pick<UserJobListPublic, 'id' | 'name' | 'uname'>
  | Pick<UserJobPublic, 'id' | 'name' | 'uname'>
  | null
  | undefined

export const isDraftJob = (job: DraftableJob) => !job?.open_at

const PLACEHOLDER_JOB_NAMES = new Set(['new', '新建招聘', '新建岗位'])

export const isPlaceholderJobName = (value: unknown) => {
  const normalized = String(value || '').trim().toLowerCase()
  return !normalized || PLACEHOLDER_JOB_NAMES.has(normalized)
}

export const getResolvedJobDisplayName = (
  job: JobDisplayNameSource,
  fallbackProfile = '',
) => {
  const jobId = String(job?.id || '').trim()
  const storedProfile = jobId ? jobProfileStorage.get(jobId) : ''
  const profile = String(fallbackProfile || storedProfile || '').trim()
  const explicitName = String(job?.uname || job?.name || '').trim()

  if (isPlaceholderJobName(explicitName) && profile) return profile
  return explicitName || profile
}
